import { IOrganizationPriceAreaTable, IPriceArea } from "@/typings/timit";

export class PriceAreasTable {

  public priceTables: IOrganizationPriceAreaTable[] = [ 
    {
      // Espoo oraginaztion pricetable
      organizationId: "626A6858-8C19-4A69-B699-12E577CE012A",
      priceAreas: [ 
        {
        passengerGroupName: 'Vanhukset',
        transportationPermissionName: 'Vanhukset / Päivätoiminta',
        priceAreas: [8, 9.8, 19, 8, 0, 0]
        },
        {
          passengerGroupName: 'Vanhukset',
          transportationPermissionName: 'Vanhukset / Muistipalvelukeskus',
          priceAreas: [8, 9.8, 19, 8, 0, 0]
        },
        {
          passengerGroupName: 'Vanhukset',
          transportationPermissionName: 'Vanhukset / Kylvetyspalvelu',
          priceAreas: [8, 9.8, 19, 8, 0, 0]
        },
        {
          passengerGroupName: 'Vanhukset',
          transportationPermissionName: 'Vanhukset / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        // PassengerGroup Vammaiset
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Työtoiminta (oma)',
          priceAreas: [8.9, 13.8, 19, 8.8, 18.9, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Työtoiminta (osto)',
          priceAreas: [8.9, 13.8, 19, 8.8, 18.9, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Päivätoiminta (oma)',
          priceAreas: [8.9, 13.8, 19, 8.8, 18.9, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Päivätoiminta (osto)',
          priceAreas: [8.9, 13.8, 19, 8.8, 18.9, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Liven opiskelijoiden kuljetukset',
          priceAreas: [0, 0, 19, 0, 0, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Liven lomahoito',
          priceAreas: [0, 0, 19, 0, 0, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Lyhytaikainen hoito',
          priceAreas: [34.6, 34.8, 19, 34.8, 30, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaiset / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaiset / Yksilökuljetus ulkoinen',
          priceAreas: [0, 0, 0, 0, 0, 34.5]
        },
        // PassengerGroup Ap-/Ip
        {
          passengerGroupName: 'Ap-/Ip',
          transportationPermissionName: 'Ap ip / Ap- ja ip-kuljetus',
          priceAreas: [16.18, 16.18, 10.2, 16.18, 21.75, 0]
        },
        {
          passengerGroupName: 'Ap-/Ip',
          transportationPermissionName: 'Ap ip / Lomahoito',
          priceAreas: [16.18, 16.18, 10.2, 16.18, 21.75, 0]
        },
        {
          passengerGroupName: 'Ap-/Ip',
          transportationPermissionName: 'Ap ip / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 31.7]
        },
        {
          passengerGroupName: 'Ap-/Ip',
          transportationPermissionName: 'Ap ip / Yksilökuljetus ulkoinen',
          priceAreas: [0, 0, 0, 0, 0, 47.55]
        },
        // PassengerGroup Koulukuljetukset
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Koulukuljetus sisäinen',
          priceAreas: [8.74, 10.71, 10.2, 8.74, 26.89, 0]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Koulukuljetus ulkoinen',
          priceAreas: [10.71, 16.18, 10.2, 10.71, 26.89, 0]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Koulukuljetus / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 31.7]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Koulukuljetus / Yksilökuljetus ulkoinen',
          priceAreas: [0, 0, 0, 0, 0, 47.55]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Erityiskaluston kuljetus',
          priceAreas: [20.55, 21.42, 10.2, 20.55, 26.89, 0]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Erityiskaluston kuljetus / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 24.14]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Opetusjärjestelykuljetus',
          priceAreas: [0, 0, 0, 0, 0, 31.7]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Opetusjärjestelykuljetus / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 24.14]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Tapaturmakuljetus',
          priceAreas: [0, 0, 0, 0, 0, 31.7]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Tapaturmakuljetus / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 31.7]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Muut erityiskuljetukset',
          priceAreas: [0, 0, 0, 0, 0, 31.7]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Muut erityiskuljetukset / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 24.14]
        },
        // PassengerGroup Varhaiskasvatus
        {
          passengerGroupName: 'Varhaiskasvatus',
          transportationPermissionName: 'Varhaiskasvatus / Esiopetus',
          priceAreas: [0, 0, 0, 0, 0, 31.7]
        },
        {
          passengerGroupName: 'Varhaiskasvatus',
          transportationPermissionName: 'Varhaiskasvatus / Varhaiskasvatus',
          priceAreas: [0, 0, 0, 0, 0, 31.7]
        },
        {
          passengerGroupName: 'Varhaiskasvatus',
          transportationPermissionName: 'Varhaiskasvatus / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 31.7]
        },
        // PassengerGroup Lastensuojelu
        {
          passengerGroupName: 'Lastensuojelu',
          transportationPermissionName: 'Lastensuojelu / Koulukuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Lastensuojelu',
          transportationPermissionName: 'Lastensuojelu / Varhaiskasvatus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Lastensuojelu',
          transportationPermissionName: 'Lastensuojelu / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Lastensuojelu',
          transportationPermissionName: 'Lastensuojelu / Yksilökuljetus ulkoinen',
          priceAreas: [0, 0, 0, 0, 0, 34.5]
        },
        // Temporary permission
        {
          passengerGroupName: '',
          transportationPermissionName: 'Nimi puuttuu',
          priceAreas: [0, 0, 0, 0, 0, 0]
        }
      ]    
    },
    {
      // LUVN pricatable
      organizationId: "17dd2fb9-4253-4503-881d-f5cdb305ceaf",
      priceAreas: [ 
        {
        passengerGroupName: 'Vanhukset',
        transportationPermissionName: 'Vanhukset / Päivätoiminta',
        priceAreas: [8, 9.8, 19, 8, 0, 0]
        },
        {
          passengerGroupName: 'Vanhukset',
          transportationPermissionName: 'Vanhukset / Muistipalvelukeskus',
          priceAreas: [8, 9.8, 19, 8, 0, 0]
        },
        {
          passengerGroupName: 'Vanhukset',
          transportationPermissionName: 'Vanhukset / Kylvetyspalvelu',
          priceAreas: [8, 9.8, 19, 8, 0, 0]
        },
        {
          passengerGroupName: 'Vanhukset',
          transportationPermissionName: 'Vanhukset / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        // PassengerGroup Vammaiset
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Työtoiminta (oma)',
          priceAreas: [8.9, 13.8, 19, 8.8, 18.9, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Työtoiminta (osto)',
          priceAreas: [8.9, 13.8, 19, 8.8, 18.9, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Päivätoiminta (oma)',
          priceAreas: [8.9, 13.8, 19, 8.8, 18.9, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Päivätoiminta (osto)',
          priceAreas: [8.9, 13.8, 19, 8.8, 18.9, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Liven opiskelijoiden kuljetukset',
          priceAreas: [0, 0, 19, 0, 0, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Liven lomahoito',
          priceAreas: [0, 0, 19, 0, 0, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaisten kuljetukset / Lyhytaikainen hoito',
          priceAreas: [34.6, 34.8, 19, 34.8, 30, 0]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaiset / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Vammaiset',
          transportationPermissionName: 'Vammaiset / Yksilökuljetus ulkoinen',
          priceAreas: [0, 0, 0, 0, 0, 34.5]
        },
        // PassengerGroup Ap-/Ip
        {
          passengerGroupName: 'Ap-/Ip',
          transportationPermissionName: 'Ap ip / Ap- ja ip-kuljetus',
          priceAreas: [14.8, 14.8, 9.33, 14.8, 19.9, 0]
        },
        {
          passengerGroupName: 'Ap-/Ip',
          transportationPermissionName: 'Ap ip / Lomahoito',
          priceAreas: [14.8, 14.8, 9.33, 14.8, 0, 0]
        },
        {
          passengerGroupName: 'Ap-/Ip',
          transportationPermissionName: 'Ap ip / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Ap-/Ip',
          transportationPermissionName: 'Ap ip / Yksilökuljetus ulkoinen',
          priceAreas: [0, 0, 0, 0, 0, 34.5]
        },
        // PassengerGroup Koulukuljetukset
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Koulukuljetus sisäinen',
          priceAreas: [8, 9.8, 9.33, 8, 24.6, 0]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Koulukuljetus ulkoinen',
          priceAreas: [9.8, 9.8, 9.33, 9.8, 24.6, 0]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Koulukuljetus / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Koulukuljetus / Yksilökuljetus ulkoinen',
          priceAreas: [0, 0, 0, 0, 0, 34.5]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Erityiskaluston kuljetus',
          priceAreas: [18.8, 16, 9.33, 18.8, 24.6, 0]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Erityiskaluston kuljetus / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 24.14]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Opetusjärjestelykuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Opetusjärjestelykuljetus / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 24.14]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Tapaturmakuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Tapaturmakuljetus / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Muut erityiskuljetukset',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Koulukuljetukset',
          transportationPermissionName: 'Muut erityiskuljetukset / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 24.14]
        },
        // PassengerGroup Varhaiskasvatus
        {
          passengerGroupName: 'Varhaiskasvatus',
          transportationPermissionName: 'Varhaiskasvatus / Esiopetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Varhaiskasvatus',
          transportationPermissionName: 'Varhaiskasvatus / Varhaiskasvatus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Varhaiskasvatus',
          transportationPermissionName: 'Varhaiskasvatus / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        // PassengerGroup Lastensuojelu
        {
          passengerGroupName: 'Lastensuojelu',
          transportationPermissionName: 'Lastensuojelu / Koulukuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Lastensuojelu',
          transportationPermissionName: 'Lastensuojelu / Varhaiskasvatus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Lastensuojelu',
          transportationPermissionName: 'Lastensuojelu / Yksilökuljetus',
          priceAreas: [0, 0, 0, 0, 0, 29]
        },
        {
          passengerGroupName: 'Lastensuojelu',
          transportationPermissionName: 'Lastensuojelu / Yksilökuljetus ulkoinen',
          priceAreas: [0, 0, 0, 0, 0, 34.5]
        },
        // Temporary permission
        {
          passengerGroupName: '',
          transportationPermissionName: 'Nimi puuttuu',
          priceAreas: [0, 0, 0, 0, 0, 0]
        }
      ]    
    }
  ];

  // tslint:disable-next-line:no-empty
  constructor() {}

  getPriceAreasForPassengerGroups(organizationId: string, groups?: string[], priceArea?: number) {
    let result: IPriceArea[] = [];
    
    const priceTable = this.priceTables.find(p => p.organizationId.toLowerCase() === organizationId.toLowerCase());
    if (!priceTable) {
      return [
              {
                passengerGroupName: '',
                transportationPermissionName: 'Nimi puuttuu',
                priceAreas: [0, 0, 0, 0, 0, 0]
              }
            ];
    }
    const areas = priceTable.priceAreas;
    if (groups) {

      if (!priceArea) {
        result = areas.filter(a => groups.some(g => g === a.passengerGroupName) ||
         a.transportationPermissionName === 'Nimi puuttuu')
        return result.sort((a, b) => a.transportationPermissionName.localeCompare(b.transportationPermissionName))
      }

      result = areas.filter(a => groups.some(g => g === a.passengerGroupName) ||
        a.transportationPermissionName === 'Nimi puuttuu')
      .filter(g => g.priceAreas[priceArea - 1] > 0 || g.transportationPermissionName === 'Nimi puuttuu');

      if (result.length < 1) {
        return areas.sort((a, b) => a.transportationPermissionName.localeCompare(b.transportationPermissionName));
      }

      return result.sort((a, b) => a.transportationPermissionName.localeCompare(b.transportationPermissionName));
    }
    return areas.sort((a, b) => a.transportationPermissionName.localeCompare(b.transportationPermissionName));
  }

  // getPrice(transportationPermissionName: string, priceArea: number) {
  //   const transportationPermission = this.areas
  //     .find(a => a.transportationPermissionName === transportationPermissionName);

  //   if (!transportationPermissionName) {
  //     return 0;
  //   }
  //   return transportationPermission.priceAreas[priceArea - 1];
  // }

}

export default PriceAreasTable;
